module.exports = __webpack_public_path__ + "static/media/Davos Seaworth 2.88354e94.jpg";